import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { catchError, EMPTY, finalize } from 'rxjs';
import { InfoboxService } from '@/common/infobox/infobox.service';
import type { GusCompany } from '@/organization/organization/organization.model';
import { OrganizationGusApiService } from './organization-gus.api.service';
import { normalizeNip } from '@/common/utils/nip.util';

@Component({
	selector: 'app-organization-data-download',
	templateUrl: './organization-data-download.component.html',
	styleUrls: ['./organization-data-download.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationDataDownloadComponent {
	readonly isLoading = signal(false);

	private readonly gusApi = inject(OrganizationGusApiService);
	private readonly infobox = inject(InfoboxService);
	private readonly dialogRef = inject<MatDialogRef<OrganizationDataDownloadComponent, GusCompany>>(MatDialogRef);

	uploadOrganizationData(value: string): void {
		const nip = normalizeNip(value);

		if (!nip) {
			this.infobox.warning('Wprowadź numer NIP');
			return;
		}

		if (this.isLoading()) {
			return;
		}

		this.isLoading.set(true);

		this.gusApi
			.getCompany(nip)
			.pipe(
				catchError((error: unknown) => {
					this.infobox.error(
						error instanceof HttpErrorResponse && error.status === 404
							? 'Nie znaleziono podmiotu o podanym NIP w rejestrze GUS'
							: 'Nie udało się pobrać danych z GUS',
					);
					return EMPTY;
				}),
				finalize(() => this.isLoading.set(false)),
			)
			.subscribe((company) => this.dialogRef.close(company));
	}
}
